export default [
  {
    path: "/hydra/sociedad",
    name: "hydra_maquina_sociedad",
    component: () => import("@/views/hydra_mantenedores/sociedad/sociedad.vue"),
    meta: {
      pageTitle: "Sociedad",
      breadcrumb: [
        {
          text: "Control de sociedades",
          active: true,
        },
      ],
      resource: "HM Sociedad",
      action: "menu",
    },
  },
  {
    path: "/hydra/maquina",
    name: "hydra_maquina",
    component: () => import("@/views/hydra_mantenedores/maquina/maquina.vue"),
    meta: {
      pageTitle: "Maquina",
      breadcrumb: [
        {
          text: "Control de maquina de hydra",
          active: true,
        },
      ],
      resource: "HM Maquina",
      action: "menu",
    },
  },
  {
    path: "/hydra/maquina-variedad",
    name: "hydra_maquina_variedad",
    component: () => import("@/views/hydra_mantenedores/maquinavariedad/maquinavariedad.vue"),
    meta: {
      pageTitle: "Maquina Variedad",
      breadcrumb: [
        {
          text: "Control de maquina de hydra por variedad",
          active: true,
        },
      ],
      resource: "HM Maquina Variedad",
      action: "menu",
    },
  },

  {
    path: "/hydra/formatos",
    name: "hydra_formatos",
    component: () => import("@/views/hydra_mantenedores/formato/formato.vue"),
    meta: {
      pageTitle: "Formatos",
      breadcrumb: [
        {
          text: "Control de formatos",
          active: true,
        },
      ],
      resource: "HM Formatos",
      action: "menu",
    },
  },
  {
    path: "/hydra/categorizacion",
    name: "hydra_categorizacion",
    component: () => import("@/views/hydra_mantenedores/categorizacion/categorizacion.vue"),
    meta: {
      pageTitle: "Categorizacion",
      breadcrumb: [
        {
          text: "Control de Categorizacion",
          active: true,
        },
      ],
      resource: "HM Categorizacion",
      action: "menu",
    },
  },

  {
    path: "/hydra/defectos",
    name: "hydra_defectos",
    component: () => import("@/views/hydra_mantenedores/defecto/defecto.vue"),
    meta: {
      pageTitle: "Defectos",
      breadcrumb: [
        {
          text: "Control de defectos",
          active: true,
        },
      ],
      resource: "HM Defectos",
      action: "menu",
    },
  },


  {
    path: "/hydra/categoria-evaluacion",
    name: "categoria_evaluacion",
    component: () => import("@/views/hydra_mantenedores/categoriaevauluacion/categoriaevaluacion.vue"),
    meta: {
      pageTitle: "Categoria evaluacion",
      breadcrumb: [
        {
          text: "Control de categoria evaluacion",
          active: true,
        },
      ],
      resource: "HM Categoria evaluacion",
      action: "menu",
    },
  },

  {
    path: "/hydra/formato-defectos",
    name: "hydra_formato_defectos",
    component: () => import("@/views/hydra_mantenedores/formato_defecto/formato_defecto.vue"),
    meta: {
      pageTitle: "Formato-Defectos",
      breadcrumb: [
        {
          text: "Control de defectos",
          active: true,
        },
      ],
      resource: "HM Formato Defectos",
      action: "menu",
    },
  },

  {
    path: "/hydra/correlacion",
    name: "correlacion",
    component: () => import("@/views/hydra_mantenedores/correlacion/correlacion.vue"),
    meta: {
      pageTitle: "Correlacion",
      breadcrumb: [
        {
          text: "Control de correlacion",
          active: true,
        },
      ],
      resource: "HM Correlacion",
      action: "menu",
    },
  },

  {
    path: "/hydra/tolerancia",
    name: "tolerancia",
    component: () => import("@/views/hydra_mantenedores/tolerancia/tolerancia.vue"),
    meta: {
      pageTitle: "Tolerancia",
      breadcrumb: [
        {
          text: "Control de Tolerancia",
          active: true,
        },
      ],
      resource: "HM Tolerancia",
      action: "menu",
    },
  },
];
